import Helmet from 'react-helmet'
import React from 'react'
import cx from 'classnames'
import intercomUpdate from 'decorators/intercomUpdate'
import { Form } from 'components/Form'
import { observer } from 'mobx-react'
import ProgressSpinner from 'components/ProgressSpinner'
import FlexCenter from 'components/FlexCenter'
import UserCoupon from 'components/UserCoupon'
import ErrorLabel from 'components/ErrorLabel'
import { HeaderSink, HeaderTitle } from 'components/Header'
import './styles.sass'

@intercomUpdate({ screen: 'Coupons' })
@observer
export default class CouponsScreen extends React.Component {
  componentWillMount () {
    this.props.rootStore.couponsScreenStore.activate()
  }

  renderCoupons (coupons) {
    return (
      <div className="coupons-list">
        {coupons.map((userCoupon) =>
          <UserCoupon key={userCoupon.id} userCoupon={userCoupon} />
        )}
      </div>
    )
  }

  render () {
    const store = this.props.rootStore.couponsScreenStore
    return (
      <div className="coupons-screen">
        <Helmet title="Coupons" />
        <HeaderSink small>
          <HeaderTitle>
            Coupons
          </HeaderTitle>
        </HeaderSink>
        <div className="has-vspacing">
          <div className="container">
            <div className="columns">
              <div className="column is-8 is-offset-2">
                <div className="content">
                  <p>This is your coupon stash. Coupons go towards your next purchase.</p>
                  <p>If you have a coupon, you may apply it here or at checkout.</p>
                </div>

                <Form onSubmit={() => store.applyCoupon()}>
                  <p className="control has-addons">
                    <input
                      type="text"
                      disabled={store.processing}
                      className="input coupon-field"
                      placeholder="Enter your coupon code here"
                      value={store.couponCode}
                      onChange={e => store.setCouponCode(e.target.value)}
                    />
                    <button type="submit" className={cx('button is-info', store.processing && 'is-loading')} disabled={store.processing}>
                      Apply
                    </button>
                  </p>
                  <ErrorLabel>{store.errorMessage}</ErrorLabel>
                </Form>

                {store.fetching
                  ? (
                    <FlexCenter className="has-spacing-top">
                      <ProgressSpinner blue />
                    </FlexCenter>
                  )
                  : this.renderCoupons(store.coupons)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/Coupons/index.jsx